import { texts } from '../config';

export * from './dates';
export * from './sorting';
export * from './tasks';

export const getErrorText = (error: unknown) => {
  if (typeof error === 'string') {
    return error;
  }

  if (error instanceof Object) {
    return Object.values(error)[0]?.error ?? texts.defaultError;
  }

  return texts.defaultError;
};
